<template>
    <Progressbar v-if="loading && !order.id" />
    <NetworkError v-else-if="errors" @tryAgain="getData" />
    <div class="flex flex-row gap-6 w-full h-full" v-else>
        <div class="flex flex-1 flex-col">
            <div class="flex items-center">
                <div class="alert bg-green-custom-1 text-green-custom-2 h-8 lg:h-12 py-0 px-2 md:px-4">
                    <span class="m-auto"> {{ __('Order details') }}</span>
                </div>
                <label class="btn btn-dark btn-outline mr-3" @click="exportOrder(order)"><ArrowDownTrayIcon class="w-5 h-5" /> <span class="hidden md:inline mr-2"> </span>{{ __('Invoice') }}</label>
            </div>
            <div class="card bg-white mt-4 !overflow-visible">
                <div class="card-body">
                    <div class="grid grid-cols-2 xl:grid-cols-4 gap-4">
                        <p class="text-sm md:text-base"><span class="text-gray-custom-1">{{ __('Order Id') }}:</span> <span>{{ order.id }}</span></p>
                        <p class="text-sm md:text-base"><span class="text-gray-custom-1">{{ __('Payable Amount') }}:</span> <span>
                                {{ order.amount?.toLocaleString() }}</span>
                            <Currency />
                        </p>
                             <p class="text-sm md:text-base"><span class="text-gray-custom-1">{{ __('Payment Method') }}:</span> <span>{{
                            __(order.payment?.method) }}</span> <small v-if="order.payment?.gateway">({{ __(order.payment?.gateway?.capitalize()) }})</small> </p>
                         <p class="text-sm md:text-base"><span class="text-gray-custom-1">{{ __('Order registration date') }}:</span> <span>{{
                            order.created_at }}</span></p>
                         <p class="text-sm md:text-base" v-if="order.delivery_date"><span class="text-gray-custom-1">{{ __('Delivery time') }}:</span> <span>{{
                            order.delivery_date ?? '---' }}</span></p>
                    </div>
                    <div class="divider min-h-0 my-0"></div>
                    <div class="grid grid-cols-2 xl:grid-cols-4 gap-4">
                        <p class="text-sm md:text-base"><span class="text-gray-custom-1">{{ __('Recipient') }}:</span> <span>{{ order.shipping_name
                        }}</span></p>
                        <p class="text-sm md:text-base"><span class="text-gray-custom-1">{{ __('Phone') }}:</span> <span>{{ order.shipping_phone
                        }}</span></p>
                        <p class="text-sm md:text-base"><span class="text-gray-custom-1">{{ __('City') }}:</span> <span>{{ order.shipping_town
                        }}</span></p>
                        <p class="text-sm md:text-base"><span class="text-gray-custom-1">{{ __('Postal Code') }}:</span> <span>{{ order.shipping_postal_code
                        }}</span></p>
                        
                        <p class="col-span-full text-sm md:text-base"><span class="text-gray-custom-1">{{ __('Address') }}:</span> <span>{{
                            order.shipping_address }}</span></p>
                    </div>
                    <div class="divider min-h-0 my-0" v-if="order.step?.name"></div>
                    <!-- <div class="overflow-x-auto text-center">
                    <ul class="steps w-[32rem] xl:w-[42rem] mx-auto">
                        <li :data-content="order.steps.includes(step.name) ? '✓' : '●'" class="step text-sm" v-for="step in meta.steps"
                            :class="{ 'step-success': order.steps.includes(step.name) }">{{ step.label }}</li>
                    </ul>
                    </div> -->
                    <div class="flex flex-col md:flex-row justify-around items-center gap-4" v-if="order.step?.name">
                        <div class="w-full md:w-64 xl:w-96" v-if="order.payment?.method != 'online' || order.payment?.status == 'complete'">
                            <p :class="`mb-1 text-${order.step.color}`">{{ order.step.label }}</p>
                            <progress :class="`progress progress-${order.step.color}`" :value="stepPercentage" max="100"></progress>
                        </div>
                        <div class="w-full md:w-64 xl:w-96" v-else>
                              <div class="flex justify-between">
                                <p class="mb-1 text-info">{{ __('Awaiting payment') }}</p>
                                <a class="btn btn-sm btn-info" :href="order.payment.link">{{ __('Payment') }}</a>
                              </div>
                              <small>{{ __('Please make your payment to avoid cancellation of your order.') }}</small>
                        </div>
                    <div v-if="order.delivery_code && order.step.name != 'delivered_to_customer'" class="flex flex-col w-full md:w-80 xl:w-96">
                        <div class="alert alert-secondary flex-row justify-center text-xs md:text-sm w-full mb-1 !text-black">
                      {{ __('Delivery code') }}:  {{ order.delivery_code }}
                    </div>
                    <p class="text-xs sm:text-sm text-center text-gray-custom-1">{{ __('Give this code to the driver after receiving the order.') }}</p>
                    </div>
                    </div>
                </div>
            </div>
            <div class="flex justify-between items-center mt-3">
                <div class="card-title">{{ __('Products') }}</div>
                <!-- <router-link class="btn btn-sm btn-error" :to="{name: 'order.return.register',params: {id: order.id}}" v-if="meta.can_return">{{ __('Register a return request') }}</router-link> -->
            </div>
          
                <div class="card mt-4 bg-white !overflow-visible">
                    <div class="card-body p-0 overflow-x-auto">
                    <div class="w-48 md:w-full">
                        <table class="table w-full table-compact xl:table-normal ">
                            <thead class="border-b">
                                <tr>
                                    <th>#</th>
                                    <th>{{ __('Product Code') }}</th>
                                    <th>{{ __('Title') }}</th>
                                    <th>{{ __('Price') }}</th>
                                    <th>{{ __('Quantity') }}</th>
                                    <th>{{ __('Sum total') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(product,index) in order.products">
                                    <td class="text-center">{{ index + 1 }}</td>
                                    <td class="text-center">{{ product.code }}</td>
                                    <td class="text-center">{{ product.title }}</td>
                                    <td class="text-center">
                                        {{ product.price.toLocaleString() }}<Currency />
                                    </td>
                                    <td class="text-center">{{ product.quantity }}</td>
                                    <td class="text-center">
                                        {{ (product.quantity * product.price).toLocaleString() }}<Currency />
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    </div>
                  
                </div>
            
           <div class="card mt-4 bg-white !overflow-visible w-full xl:max-w-screen-md xl:mr-auto">
                    <div class="card-body p-0 overflow-x-auto">
                    <div class="w-full" v-if="order.checks?.length">
                        <table class="table w-full table-compact xl:table-normal">
                            <thead class="border-b">
                                <tr>
                                    <th class="!text-white !bg-green-custom-6">{{ __('Number of goods') }}</th>
                                    <th class="!text-white !bg-green-custom-6">{{ __('settlement semester') }}</th>
                                    <th class="!text-white !bg-green-custom-6">{{ __('settlement date') }}</th>
                                    <th class="!text-white !bg-green-custom-6">{{ __('Amount') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="check in order.checks" class="bg-white even:bg-green-custom-5">
                                    <td class="text-black text-center">{{ check.product_count }}</td>
                                    <td class="text-black text-center">{{ check.term + ' ' + __('Day') }}</td>
                                    <td class="text-black text-center">{{ check.date }}</td>
                                    <td class="text-black text-center">
                                        <span class="text-black">{{ check.amount.toLocaleString() }}</span>
                                        <Currency />
                                    </td>
                                </tr>
                                <tr class="bg-green-custom-2">
                                    <td colspan="2" class="text-red-custom-2">{{ __('Clearing date on a check') }}</td>
                                    <td colspan="2" class="text-red-custom-2">{{ order.check }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
              </div>
        </div>
    </div>
</template>
<script setup>
import { computed, onMounted, onUpdated, ref } from 'vue';
import {
    ArrowDownTrayIcon,
} from '@heroicons/vue/24/outline'
import Currency from '../../svg/Currency.vue';
import useOrders from "../../../composables/shop/order";
const { errors, loading, order, getOrder, exportOrder, meta } = useOrders();
const getData = () => getOrder();
const stepPercentage = computed(() => order.steps.length * 100 / (order.steps.includes('suspended') ? 7 : 6));
onMounted(() => {
    getData()
});
</script>